export default __webpack_public_path__ + "static/media/person-icon.fe2ba98d.png";